// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_LinkDespesasInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/expense_conciliation_link_despesas/{period_id}
 *
 * Validates input for linking despesas to a payroll period.
 */
import { registerContract } from './validate'

export interface Payroll_LinkDespesasInput {
despesa_ids: number[]
}

registerContract('Payroll_LinkDespesasInput', {
  despesa_ids: { type: 'array',   required: true },
})
